let hidden = "hidden";
let eventName = "visibilitychange";

if ("mozHidden" in document) {
    hidden = "mozHidden";
    eventName = "mozvisibilitychange";
} else if ("webkitHidden" in document) {
    hidden = "webkitHidden";
    eventName = "webkitvisibilitychange";
} else if ("msHidden" in document) {
    hidden = "msHidden";
    eventName = "msvisibilitychange";
}

export default function addOnVisibilityChange(onVisibilityChange: Function) {
    document.addEventListener(eventName, visibilityChange.bind(this, onVisibilityChange));
}

function visibilityChange(onVisibilityChange: Function) {
    onVisibilityChange(!document[hidden]);
}

